export default "__VITE_ASSET__Rrtw7NvE__"